import { Button, Stack, Typography } from "@mui/material";
import { theme } from "src/assets/theme";

interface Props {
  count: number;
  handleOpen: () => void;
}

const Actions = ({ count, handleOpen }: Props) => {
  return (
    <Stack
      width="100%"
      height={60}
      direction="row"
      bgcolor={theme.palette.teal[100]}
      justifyContent="space-between"
      alignItems="center"
      padding={"0 16px"}
    >
      <Typography>Selected: {count}</Typography>
      <Button size="small" variant="secondary" onClick={handleOpen}>
        Transfer
      </Button>
    </Stack>
  );
};

export default Actions;
